import { useEffect, useRef } from 'react';
import IconWrapper from '@components/ui/Icons';
import Heading from '@components/ui/Heading';
import { useTranslation } from 'next-i18next';
import { usePdp } from '@context/PdpContext';

import styles from './AlbyPDP.module.scss';

interface AlbyWebComponent extends HTMLElement {
  switchProduct: (productId: string, variantId: string) => Promise<void>;
}

const AlbyPDP = ({ productCode }: { productCode: string }) => {
  const { t } = useTranslation('pdp');
  const { selectedVariant } = usePdp();

  const albyRef = useRef<AlbyWebComponent | null>(null);

  const handleProductChange = async (productId: string, variantId: string) => {
    if (
      albyRef.current &&
      typeof albyRef.current.switchProduct === 'function'
    ) {
      await albyRef.current.switchProduct(productId, variantId);
    }
  };

  useEffect(() => {
    if (selectedVariant?.entityId) {
      handleProductChange(productCode, selectedVariant?.entityId.toString());
    }
  }, [productCode, selectedVariant?.entityId]);

  return (
    <div className={styles.albyQA} id="alby-qa">
      <div className={styles.albyHeading}>
        <Heading
          styleLevel="4"
          semanticLevel="h2"
          className={styles.albyHeading}
        >
          {t('product.alby.instantAnswers')}
        </Heading>
        <IconWrapper icon="sparkle" height={20} width={20} />
      </div>
      <alby-generative-qa
        ref={albyRef}
        widget-id={process.env.NEXT_PUBLIC_ALBY_PDP_WIDGET_ID}
        product-id={productCode}
        test-mode={process.env.VERCEL_ENV === 'production' ? 'false' : 'true'}
      ></alby-generative-qa>
    </div>
  );
};

export default AlbyPDP;
